/* Asset-class switch: the terminal's key strip (violet frame, filled key for
   the current class) after .screen-switch in terminal.css, with room for a
   value caption under each label. The strip scrolls inside its own frame at
   phone width so the page never scrolls sideways. */

.switch {
  position: relative;
  display: flex;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: thin;
  border: 1px solid var(--line);
  border-radius: 7px;
}

.key {
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1px;
  min-height: 34px;
  padding: 9px 12px;
  background: var(--paper-raised);
  color: var(--ink-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
  text-decoration: none;
  text-transform: none;
  white-space: nowrap;
}

.key + .key {
  border-left: 1px solid var(--line);
}

.key:hover {
  color: var(--ink);
}

/* The focus ring sits inside the scroll frame so it is never clipped. */
.key:focus-visible {
  outline-offset: -3px;
}

.key[aria-current="page"] {
  background: #272033;
  color: #d2bcff;
}

.keyLabel {
  display: block;
}

/* Full labels on wide screens; short ones at phone width, with the full label
   kept for screen readers. */
.short {
  display: none;
}

@media (max-width: 640px) {
  .full {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }

  .short {
    display: inline;
  }
}

@media (max-width: 480px) {
  .key {
    padding-inline: 7px;
    font-size: 0.74rem;
    letter-spacing: 0.03em;
  }
}

/* The switch's frame. */
.wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}
